import { InsertDriveFile as FileIcon } from "@mui/icons-material";
import { DocFileIconSVG, ImageFileIconSVG, PDFFileIconSVG, XlsFileIconSVG } from "../../../assets/customIcons";
export var renderIcon = function (contentType) {
    var _contentType$split$;
    var type = contentType === null || contentType === void 0 || (_contentType$split$ = contentType.split('.')[1]) === null || _contentType$split$ === void 0 ? void 0 : _contentType$split$.toLowerCase();
    switch (type) {
        case 'png':
        case 'jpg':
        case 'jpeg':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    color: 'secondary.200'
                }
            });
        case 'doc':
        case 'docx':
            return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    color: 'secondary.200'
                }
            });
        case 'xls':
        case 'xlsx':
        case 'csv':
            return /*#__PURE__*/ React.createElement(XlsFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    color: 'secondary.200'
                }
            });
        case 'pdf':
            return /*#__PURE__*/ React.createElement(PDFFileIconSVG, {
                sx: {
                    width: 40,
                    height: 40,
                    color: 'secondary.200'
                }
            });
        default:
            return /*#__PURE__*/ React.createElement(FileIcon, {
                sx: {
                    fontSize: 40,
                    color: "gray"
                }
            });
    }
};
